module.exports = __webpack_public_path__ + "static/media/doubleDoor.b1cef588.png";